(() => {
  'use strict';

  const EMPTY_TEXTS = new Set([
    'Nenájdené žiadne položky',
    'Nenájdené žiadne výsledky',
    'No items found',
    'No results found'
  ]);

  function normalizeText(value) {
    return String(value || '').replace(/\s+/g, ' ').trim();
  }

  function hideEmptyNoise(widget) {
    widget.querySelectorAll('*').forEach((el) => {
      if (el.children.length > 0) return;
      if (EMPTY_TEXTS.has(normalizeText(el.textContent))) {
        el.classList.add('cr-jdgm-hide');
        el.setAttribute('aria-hidden', 'true');
      }
    });
  }

  function markState(widget) {
    const reviews = widget.querySelectorAll('.jdgm-rev');
    const hasRealReview = Array.from(reviews).some((review) => {
      if (review.closest('[data-cr-sample]')) return false;
      return normalizeText(review.textContent).length > 20;
    });
    widget.dataset.crEmpty = hasRealReview ? 'false' : 'true';
  }

  function polish() {
    document.querySelectorAll('.jdgm-rev-widg').forEach((widget) => {
      hideEmptyNoise(widget);
      markState(widget);
    });
  }

  let raf = 0;
  const schedule = () => {
    cancelAnimationFrame(raf);
    raf = requestAnimationFrame(polish);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule, { once: true });
  } else {
    schedule();
  }

  const observer = new MutationObserver(schedule);
  observer.observe(document.documentElement, { childList: true, subtree: true });

  window.addEventListener('load', schedule, { once: true });
})();
